module.exports = __webpack_public_path__ + "img/hroz.e591d8c.jpg";